exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".numeric-summary .label[data-v-211bcc75]{max-width:10rem}.numeric-summary .value[data-v-211bcc75]{width:4rem}h4[data-v-211bcc75]{margin-top:0}.secondary[data-v-211bcc75]{font-size:12px;font-style:italic;white-space:pre-line;word-break:break-word}.po-number[data-v-211bcc75]{display:inline-block;padding-left:20px;font-size:14px;color:#dd711f}.print-version[data-v-211bcc75]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-211bcc75","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/Order.vue
// module id = 490
// module chunks = 0